import { FC } from "react";
import { useMatch } from "react-router";
import { RoutePath } from "src/data/Routes";
import { GLOB } from "src/util/Glob";
import NavigateRoute from "./NavigateRoute";
import { useNavProps } from "./useNavProps";

export const RouteDevice: FC = () => {
  const match = useMatch(RoutePath.MATCH_DEVICE);
  const navProps = useNavProps(search => {
    const cls = match.params.class;
    let type = match.params.type;
    let item = match.params.item;
    const device = GLOB.menuService.storagesBy.device;
    if (!item && device.children && !device.children.some(mn => mn.title === type && mn.hwType)) {
      item = type;
      type = null;
    }
    return { clsName: cls, allType: RoutePath.DEVICE, typeOrDevice: type, itemName: item, search };
  }, [match.params]);

  return navProps && <NavigateRoute {...navProps} />;
};
